var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { class: _vm.getNavClassName() }, [
    _c(
      "a",
      {
        staticClass: "pagination-previous",
        attrs: { disabled: _vm.outOfRegion(_vm.formatCurrentPage - 1) },
        on: {
          click: function ($event) {
            return _vm.onPageClick(_vm.currentPage - 1)
          },
        },
      },
      [_vm._v("Previous")]
    ),
    _c(
      "a",
      {
        staticClass: "pagination-next",
        attrs: { disabled: _vm.outOfRegion(_vm.formatCurrentPage + 1) },
        on: {
          click: function ($event) {
            return _vm.onPageClick(_vm.currentPage + 1)
          },
        },
      },
      [_vm._v("Next page")]
    ),
    _c(
      "ul",
      { staticClass: "pagination-list" },
      _vm._l(_vm.pagingList, function (item, index) {
        return _c("li", { key: index }, [
          item !== "..."
            ? _c(
                "a",
                {
                  class: _vm.getPagingClassName(item),
                  on: {
                    click: function ($event) {
                      return _vm.onPageClick(item)
                    },
                  },
                },
                [_vm._v(_vm._s(item))]
              )
            : _c("span", { staticClass: "pagination-ellipsis" }, [
                _vm._v("..."),
              ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }